<template>
  <Dialog
    width="600px"
    titleAlign="left"
    :title="$$t('create.download_ownership_certificate')"
    :visible="renderData.visible"
    @close="closeDialog"
    mobileRenderType="drawerDialog"
  >
    <div
      class="height-all download-copyright flex-column"
      :class="{ 'download-copyright-mobile': createRenderType == 'mobile' }"
    >
      <Information
        :title="$$t('create.download_ownership_certificate_information')"
        ref="childInfo"
      ></Information>

      <div class="download-copyright-done-btn-box">
        <div class="download-copyright-done-btn">
          <Button
            @click="onDoneClick"
            :renderStyle="{
              '--padding': '0',
              '--width': '100%',
              '--height': '48px',
              '--borderRadius': '50px',
              '--fontColor': '#000',
              '--fontSize': '16px',
              '--fontWeight': 'normal',
              '--border': 'none',
              '--background':
                'linear-gradient(120deg, rgb(79, 222, 255, 1) -1%, rgb(230, 117, 255, 1) 100%)', //#94ADFF
              '--backgroundHover':
                'linear-gradient(120deg, rgb(79, 222, 255, 0.75) -1%, rgb(230, 117, 255, 0.75) 100%)',
              '--fontColorHover': '#000',
            }"
          >
            {{ $$t("create.download_ownership_certificate_btn") }}
          </Button>
        </div>
      </div>
      <!-- <div
        v-if="$$language() != 'cn'"
        class="download-copyright-remainder-credits tc"
      >
        {{ $$t("create.credits_not_enough") }}
      </div> -->
    </div>
    <!-- <QrCodePayDialog
      :dialogTitle="$$t('create.buy_song_copyright')"
      :totalPrice="99"
      :qrCode="renderData.qrCode"
      :orderId="renderData.orderId"
      v-model:visible="renderData.payDialogVisible"
      v-if="renderData.payDialogVisible"
      :paySuccess="onPaySuccess"
      :payFail="onPayFail"
    ></QrCodePayDialog> -->
  </Dialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";

import globalConfig, { chinaAppName } from "@/config/config.js";
import { useRouter, useRoute } from "vue-router";
import Dialog from "@/components/basic/dialog/Dialog.vue";
import Button from "@/components/basic/button/Button.vue";
import Record from "@/components/media/record/Record.vue";
import Select from "@/components/basic/select/Select.vue";
// import QrCodePayDialog from "@/components/wxPayDialog/wxPayDialog.vue";
import Information from "@/components/information/index.vue";
import { payOrder, checkSongOrder } from "@/api/api/apiCommon.js";
import message from "@/components/functionCallComponent/message.jsx";

import useUserDataStore from "@/store/userDataStore.js";
const userDataStore = useUserDataStore();

import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);
import { handlePayMoney } from "@/utils/pay.js";
import { isMobileDevice } from "@/utils/tools.js";
import {
  StyleLabelData,
  EmotionalLabelData,
  getEnOptions,
  getSelectValue,
} from "@/config/const.js";
const Router = (getCurrentInstance() || (window?.$getVueCurrentInstance?.())).appContext?.config?.globalProperties?.$router;
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const props = defineProps({
  item: {
    type: Object,
    default: null,
  },
  pitem: {
    type: Object,
    default: null,
  },
  visible: {
    type: Boolean,
    default: false,
  },
  orderId: {
    type: Number,
    default: "",
  },
});
const emits = defineEmits(["update:visible", "done", "complete"]);

const childInfo = ref(null);

const renderData = reactive({
  visible: props.visible,
  userCredits: userDataStore.credits,
  payDialogVisible: false,
  qrCode: null,
  orderId: null,
});

const onClose = () => {
  renderData.visible = false;
  emits("update:visible", false);
  emits("cancel");
};
// 微信支付
const payWxMoney = () => {
  let closeMsg = message.loading({
    position: "center",
    content: $$t("create.create_order_loading"),
  });
  checkSongOrder({
    song_id: props.item.song_id,
    t: 3,
    channel: isMobileDevice() ? "wechat_h5" : "wechat_native",
  })
    .then((res) => {
      closeMsg.clear();
      if (res.code == 200) {
        const { wechat_native_url, order_id } = res.data;
        renderData.qrCode = wechat_native_url;
        renderData.orderId = order_id;
        renderData.payDialogVisible = true;
        handlePayMoney(
          { totalPrice: 99, order_id, wechat_native_url },
          () => {
            onPaySuccess();
          },
          () => {
            Router.push({
              name: "resultFail",
            });
          }
        );
      } else {
        if (res.code == 6122) {
          message.warning({
            content: $$t("create.download_copyright_failed_on_sale"),
            position: "top",
          });
        } else {
          message.warning({
            content: $$t("create.create_order_failed"),
            position: "top",
          });
        }
      }
    })
    .catch((err) => {
      closeMsg.clear();
      message.warning({
        content: $$t("create.create_order_failed"),
        position: "top",
      });
    });
};

const onDoneClick = async () => {
  // if (globalConfig.appname == chinaAppName ) {
  //   childInfo.value?.submitForm().then((res) => {
  //     payWxMoney();
  //   });
  // } else {
  childInfo.value?.submitForm().then((res) => {
    emits("complete", {}, () => {
      renderData.filename = "";
      renderData.moodTag = null;
      renderData.styleTag = null;
      emits("update:visible", false);
    });
  });
  // }
};

const onPaySuccess = () => {
  emits(
    "complete",
    {
      orderId: renderData.orderId,
    },
    () => {
      renderData.filename = "";
      renderData.moodTag = null;
      renderData.styleTag = null;
      emits("update:visible", false);
    }
  );
};
const onPayFail = () => {
  emits("update:visible", false);
  Router.push({
    name: "resultFail",
    query: {
      order_id: renderData.orderId,
    },
  });
};

const closeDialog = () => {
  renderData.visible = false;
};

const goToTerms = () => {
  window.open(window.location.origin + "/terms", "_blank");
};

watch(
  () => props.visible,
  (val) => {
    renderData.visible = props.visible;
    renderData.filename = props.item?.title;
  }
);

watch(
  () => renderData.visible,
  (val) => {
    emits("update:visible", val);
  }
);

onMounted(() => {});
</script>
<style lang="scss" scope>
.download-copyright {
  padding: 15px 40px 32px 40px;

  .information-box {
    .title {
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: normal;
      line-height: 24px;
      letter-spacing: 0em;
      color: #ffffff;
    }
    .el-form-item__content {
      padding: 12px 0;
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: normal;
      line-height: 24px;
      color: #ffffff;
    }
    .el-form-item__error {
      color: #ff5f74;
    }
  }
  .download-copyright-remainder-credits {
    font-family: HarmonyOS Sans SC;
    font-size: 16px;
    font-weight: normal;
    line-height: 20px;
    color: #ff5745;
    margin: 32px 0 0 0;
  }
  &.download-copyright-mobile {
    padding: 15px 16px 16px 16px;
    .mobile-information-box {
      .el-form {
        padding: 0;
      }
      .el-form-item {
        margin-bottom: 20px;
      }
      .disabled {
        width: 100%;
        height: 36px;
        line-height: 36px;
      }
      .el-form-item__content {
        height: 36px;
        padding: 0;
        border: none;
      }
      .el-input {
        height: 100%;
        border: none;
      }
      input {
        height: 100% !important;
        padding: 0 7px;
        border: none;
        background: transparent;
      }
      .el-input__wrapper {
        height: 36px !important;
        padding: 0;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        border: solid 1px rgba(255, 255, 255, 0.2);
        &:hover {
          background: rgba(255, 255, 255, 0.15);
        }
        &.is-focus {
          background: rgba(255, 255, 255, 0.2);
          border-radius: 8px;
          border: solid 1px #94adff;
        }
      }
    }

    .el-form {
      .el-form-item:nth-child(1) {
        .el-form-item__content {
          padding: 0px 0px;
        }
      }
      .el-form-item:nth-child(2) {
        .el-form-item__content {
          padding: 0px 0px;
        }
      }
    }
  }
}
.download-copyright-done-btn-box {
  padding: 0 32px;
  .download-copyright-done-btn {
    margin: 24px auto 0 auto;
    max-width: 162px;
  }
}
</style>
